import React, { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Login.css";
import API_BASE_URL from "../config";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!token) {
      setErrorMsg("This reset link is invalid or missing.");
      return;
    }

    if (!password || !confirmPassword) {
      setErrorMsg("Enter and confirm your new password.");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMsg("Passwords do not match.");
      return;
    }

    if (password.length < 8) {
      setErrorMsg("Password must be at least 8 characters.");
      return;
    }

    try {
      setSubmitting(true);

      const res = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          token,
          password
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Unable to reset password");
      }

      setSuccessMsg("Your password has been reset successfully.");

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 1200);
    } catch (err) {
      setErrorMsg(err.message || "Unable to reset password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-background-orb auth-background-orb-one" />
      <div className="auth-background-orb auth-background-orb-two" />

      <div className="auth-card auth-card-login">
        <div className="auth-brand">
          <div className="auth-brand-logo" aria-label="Agent Book CRM logo">
            <span>AB</span>
          </div>

          <div className="auth-brand-copy">
            <p className="auth-brand-kicker">Account Recovery</p>
            <h1 className="auth-brand-title">Reset Password</h1>
            <p className="auth-brand-subtitle">
              Create a new password for your Agent Book CRM account.
            </p>
          </div>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-form-section">
            <div className="auth-field">
              <label>New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter new password"
                autoComplete="new-password"
                required
              />
            </div>

            <div className="auth-field">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                autoComplete="new-password"
                required
              />
            </div>
          </div>

          {errorMsg && <div className="auth-error-banner">{errorMsg}</div>}
          {successMsg && <div className="auth-success-banner">{successMsg}</div>}

          <button
            type="submit"
            className="auth-primary-btn"
            disabled={submitting}
          >
            {submitting ? "Saving..." : "Reset Password"}
          </button>

          <div className="auth-secondary-actions">
            <button
              type="button"
              className="auth-ghost-btn"
              onClick={() => navigate("/login")}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}